import { render, staticRenderFns } from "./ComStateTs.vue?vue&type=template&id=60ac356e&scoped=true&"
import script from "./ComStateTs.vue?vue&type=script&lang=js&"
export * from "./ComStateTs.vue?vue&type=script&lang=js&"
import style0 from "./ComStateTs.vue?vue&type=style&index=0&id=60ac356e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ac356e",
  null
  
)

export default component.exports